import React from "react";
import CustomImageSlider from "./CustomImageSlider";

export default function TableHeader({ selectedTable, restaurant }) {
  // safe check: supports null/undefined, arrays, and objects
  const hasSelectedTable =
    selectedTable != null && // not null/undefined
    (Array.isArray(selectedTable)
      ? selectedTable.length > 0
      : // if it's an object, check it has at least one key or a tableImagePath
        typeof selectedTable === "object" &&
        (Object.keys(selectedTable).length > 0 ||
          !!selectedTable.tableImagePath));

  // prefer table image if available, otherwise fallback images
  const tableImage =
    hasSelectedTable && selectedTable.tableImagePath
      ? selectedTable.tableImagePath
      : null;

  const images = tableImage
    ? [
        tableImage,
        // "https://gotaste.uk/static/media/image%2035.3916b0ba52de526d139a.png",
        // "https://img.freepik.com/premium-photo/delicious-steak-photo-food-photography_929907-237.jpg?w=740",
      ]
    : [restaurant?.restaurantLogo];

  return (
    <div className="top-section table-slider-container position-relative">
      <CustomImageSlider images={images} tableSlider={true} />
    </div>
  );
}
